import React from "react";

interface AuthenticatedUser {
  name: string;
  email: string;
  roles: string[];
  /**
   * Keycloak id uniquely identifying this user
   */
  id: string;
}

interface Credentials {
  username: string;
  password: string;
}

export interface AuthenticationContextValue {
  user?: AuthenticatedUser;
  login: (credentials?: Credentials) => Promise<boolean>;
  getLoginHref: () => string;
  logout: () => Promise<void>;
}

const AuthenticationContext = React.createContext<AuthenticationContextValue>({
  user: undefined,
  async login() {
    return false;
  },
  getLoginHref() {
    return "";
  },
  async logout() {
    // empty
  },
});

export default AuthenticationContext;
